import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { ArrowRightIcon } from '@src/components/common/icon';

const BreadcrumbText = styled.span`
	position: relative;
	font-size: 14px;
	cursor: ${props => (props.isClickable ? 'pointer' : 'unset')};
	color: #676767;

	&:last-child {
		color: #101010;
		font-weight: 400;
	}
`;

const StyledArrowRightIcon = styled(ArrowRightIcon)`
	position: relative;
	top: 5px;
	fill: #676767;
`;

interface IBreadcrumbConfig {
	name: string;
	path?: string;
}

interface IBreadcrumb {
	className?: string;
	breadcrumbConfig: IBreadcrumbConfig[];
	splitIcon?: string | JSX.Element;
	onClick?: (path: string) => void;
}

const Breadcrumb = (
	{ className, breadcrumbConfig, splitIcon = <StyledArrowRightIcon />, onClick }:
	IBreadcrumb,
):JSX.Element => {
	const router = useRouter();

	const handleClickBreadcrumb = path => () => {
		router.push(path);
		if (onClick) onClick(path);
	};

	return (
		<div className={className}>
			{breadcrumbConfig.map((breadcrumb: IBreadcrumbConfig, index) => {
				const isLast = breadcrumbConfig.length - 1 === index;
				const isClickable = !!breadcrumb.path;

				return (
					<BreadcrumbText
						key={`breadcrumb__${breadcrumb.name}`}
						isClickable={isClickable}
						onClick={isClickable ? handleClickBreadcrumb(breadcrumb.path) : null}
					>
						{breadcrumb.name}
						{!isLast && splitIcon}
					</BreadcrumbText>
				);
			})}
		</div>
	);
};

export default Breadcrumb;
